import { Bowser } from '@factorin/util';


export const supportedBrowsers = {
    [Bowser.BROWSER_MAP.ie]: '>=11',
    [Bowser.BROWSER_MAP.opera]: '>=15',
    [Bowser.BROWSER_MAP.edge]: '>=11',
    [Bowser.BROWSER_MAP.firefox]: '>=3',
    [Bowser.BROWSER_MAP.chrome]: '>=20',
    [Bowser.BROWSER_MAP.yandex]: '>=1',
    [Bowser.BROWSER_MAP.android]: '>=4.4',
    [Bowser.BROWSER_MAP.samsung_internet]: '>=4',
    [Bowser.BROWSER_MAP.safari]: '>=9',
    [Bowser.BROWSER_MAP.uc]: '>=12.12',
    [Bowser.BROWSER_MAP.chromium]: '>=1',
};
